import React from "react";

const FedralSavings = () => {
  const schoolData = [
    {
      "Bank Name": "First American Trust, FSB",
      Address: "215 S STATE ST STE 380, SALT LAKE CITY, UT 84111",
      "CEO/President": "Matt McCreadie, CEO",
      "Contact No:": "801-578-8888",
    },
    {
      "Bank Name": "Synchrony Bank",
      Address: "170 W ELECTION RD STE 125, DRAPER, UT 84020",
      "CEO/President": "Brian Doubles, President & CEO",
      "Contact No:": "801-816-4760",
    },
  ];

  const getGoogleMapsUrl = (address) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address
    )}`;

  return (
    <div className="flex items-center justify-center my-12">
      <div className="bg-gray-300 z-10 rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
        <div className="overflow-x-auto max-h-[800px]">
          <table className="table-auto border-collapse border bg-white border-gray-300 w-full">
            <thead className="sticky top-0 z-10">
              <tr>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                  Bank Name
                </th>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                  Address
                </th>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                  Contact No
                </th>
              </tr>
            </thead>
            <tbody>
              {schoolData.map((school, index) => (
                <tr
                  key={`${school["Bank Name"]}-${index}`}
                  className="odd:bg-white even:bg-gray-100 hover:bg-gray-200"
                >
                  <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                    {school["Bank Name"]}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                    <a
                      href={getGoogleMapsUrl(school.Address)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="no-underline hover:no-underline text-blue-900"
                    >
                      {school.Address}
                    </a>
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                    {school["Contact No:"]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FedralSavings;
